import R, { useRef as j, useState as ut, useEffect as Y, useMemo as bt, useLayoutEffect as At } from "react";
function ot(t, e) {
  var r = {};
  for (var a in t)
    Object.prototype.hasOwnProperty.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, a = Object.getOwnPropertySymbols(t); n < a.length; n++)
      e.indexOf(a[n]) < 0 && Object.prototype.propertyIsEnumerable.call(t, a[n]) && (r[a[n]] = t[a[n]]);
  return r;
}
var z;
(function(t) {
  t.event = "event", t.props = "prop";
})(z || (z = {}));
function M() {
}
function xt(t) {
  var e, r = void 0;
  return function() {
    for (var a = [], n = arguments.length; n--; )
      a[n] = arguments[n];
    return e && a.length === e.length && a.every(function(o, l) {
      return o === e[l];
    }) || (e = a, r = t.apply(void 0, a)), r;
  };
}
function L(t) {
  return !!(t || "").match(/\d/);
}
function W(t) {
  return t == null;
}
function Et(t) {
  return typeof t == "number" && isNaN(t);
}
function Ft(t) {
  return W(t) || Et(t) || typeof t == "number" && !isFinite(t);
}
function Nt(t) {
  var e = j(t);
  e.current = t;
  var r = j(function() {
    for (var a = [], n = arguments.length; n--; )
      a[n] = arguments[n];
    return e.current.apply(e, a);
  });
  return r.current;
}
function it(t, e) {
  return Array(e + 1).join(t);
}
function Ot(t) {
  var e = t + "", r = e[0] === "-" ? "-" : "";
  r && (e = e.substring(1));
  var a = e.split(/[eE]/g), n = a[0], o = a[1];
  if (o = Number(o), !o)
    return r + n;
  n = n.replace(".", "");
  var l = 1 + o, s = n.length;
  return l < 0 ? n = "0." + it("0", Math.abs(l)) + n : l >= s ? n = n + it("0", l - s) : n = (n.substring(0, l) || "0") + "." + n.substring(l), r + n;
}
function tt(t, e) {
  if (t.value = t.value, t !== null) {
    if (t.createTextRange) {
      var r = t.createTextRange();
      return r.move("character", e), r.select(), !0;
    }
    return t.selectionStart || t.selectionStart === 0 ? (t.focus(), t.setSelectionRange(e, e), !0) : (t.focus(), !1);
  }
}
var Tt = xt(function(t, e) {
  for (var r = 0, a = 0, n = t.length, o = e.length; t[r] === e[r] && r < n; )
    r++;
  for (; t[n - 1 - a] === e[o - 1 - a] && o - a > r && n - a > r; )
    a++;
  return {
    from: { start: r, end: n - a },
    to: { start: r, end: o - a }
  };
}), Bt = function(t, e) {
  var r = Math.min(t.selectionStart, e);
  return {
    from: { start: r, end: t.selectionEnd },
    to: { start: r, end: e }
  };
};
function Mt(t, e, r) {
  return Math.min(Math.max(t, e), r);
}
function Z(t) {
  return Math.max(t.selectionStart, t.selectionEnd);
}
function _t() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function kt(t) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: t.length
    },
    lastValue: ""
  };
}
function ft(t, e) {
  return t === void 0 && (t = " "), typeof t == "string" ? t : t[e] || " ";
}
function Rt(t) {
  var e = t.currentValue, r = t.formattedValue, a = t.currentValueIndex, n = t.formattedValueIndex;
  return e[a] === r[n];
}
function jt(t, e, r, a, n, o, l) {
  l === void 0 && (l = Rt);
  var s = n.findIndex(function(A) {
    return A;
  }), y = t.slice(0, s);
  !e && !r.startsWith(y) && (e = y, r = y + r, a = a + y.length);
  for (var V = r.length, I = t.length, x = {}, c = new Array(V), S = 0; S < V; S++) {
    c[S] = -1;
    for (var f = 0, w = I; f < w; f++) {
      var C = l({
        currentValue: r,
        lastValue: e,
        formattedValue: t,
        currentValueIndex: S,
        formattedValueIndex: f
      });
      if (C && x[f] !== !0) {
        c[S] = f, x[f] = !0;
        break;
      }
    }
  }
  for (var d = a; d < V && (c[d] === -1 || !o(r[d])); )
    d++;
  var E = d === V || c[d] === -1 ? I : c[d];
  for (d = a - 1; d > 0 && c[d] === -1; )
    d--;
  var p = d === -1 || c[d] === -1 ? 0 : c[d] + 1;
  return p > E ? E : a - p < E - a ? p : E;
}
function G(t, e, r, a) {
  var n = t.length;
  if (e = Mt(e, 0, n), a === "left") {
    for (; e >= 0 && !r[e]; )
      e--;
    e === -1 && (e = r.indexOf(!0));
  } else {
    for (; e <= n && !r[e]; )
      e++;
    e > n && (e = r.lastIndexOf(!0));
  }
  return e === -1 && (e = n), e;
}
function Dt(t) {
  for (var e = Array.from({ length: t.length + 1 }).map(function() {
    return !0;
  }), r = 0, a = e.length; r < a; r++)
    e[r] = !!(L(t[r]) || L(t[r - 1]));
  return e;
}
function Pt(t, e, r, a, n, o) {
  o === void 0 && (o = M);
  var l = Nt(function(f, w) {
    var C, d;
    return Ft(f) ? (d = "", C = "") : typeof f == "number" || w ? (d = typeof f == "number" ? Ot(f) : f, C = a(d)) : (d = n(f, void 0), C = a(d)), { formattedValue: C, numAsString: d };
  }), s = ut(function() {
    return l(W(t) ? e : t, r);
  }), y = s[0], V = s[1], I = function(f, w) {
    f.formattedValue !== y.formattedValue && V({
      formattedValue: f.formattedValue,
      numAsString: f.value
    }), o(f, w);
  }, x = t, c = r;
  W(t) && (x = y.numAsString, c = !0);
  var S = l(x, c);
  return bt(function() {
    V(S);
  }, [S.formattedValue]), [y, I];
}
function Lt(t) {
  return t.replace(/[^0-9]/g, "");
}
function Kt(t) {
  return t;
}
function Ut(t) {
  var e = t.type;
  e === void 0 && (e = "text");
  var r = t.displayType;
  r === void 0 && (r = "input");
  var a = t.customInput, n = t.renderText, o = t.getInputRef, l = t.format;
  l === void 0 && (l = Kt);
  var s = t.removeFormatting;
  s === void 0 && (s = Lt);
  var y = t.defaultValue, V = t.valueIsNumericString, I = t.onValueChange, x = t.isAllowed, c = t.onChange;
  c === void 0 && (c = M);
  var S = t.onKeyDown;
  S === void 0 && (S = M);
  var f = t.onMouseUp;
  f === void 0 && (f = M);
  var w = t.onFocus;
  w === void 0 && (w = M);
  var C = t.onBlur;
  C === void 0 && (C = M);
  var d = t.value, E = t.getCaretBoundary;
  E === void 0 && (E = Dt);
  var p = t.isValidInputCharacter;
  p === void 0 && (p = L);
  var A = t.isCharacterSame, B = ot(t, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), K = Pt(d, y, !!V, l, s, I), et = K[0], b = et.formattedValue, U = et.numAsString, vt = K[1], $ = j(), q = j({ formattedValue: b, numAsString: U }), rt = function(i, u) {
    q.current = { formattedValue: i.formattedValue, numAsString: i.value }, vt(i, u);
  }, nt = ut(!1), lt = nt[0], ct = nt[1], D = j(null), _ = j({
    setCaretTimeout: null,
    focusTimeout: null
  });
  Y(function() {
    return ct(!0), function() {
      clearTimeout(_.current.setCaretTimeout), clearTimeout(_.current.focusTimeout);
    };
  }, []);
  var st = l, H = function(i, u) {
    var v = parseFloat(u);
    return {
      formattedValue: i,
      value: u,
      floatValue: isNaN(v) ? void 0 : v
    };
  }, k = function(i, u, v) {
    i.selectionStart === 0 && i.selectionEnd === i.value.length || (tt(i, u), _.current.setCaretTimeout = setTimeout(function() {
      i.value === v && i.selectionStart !== u && tt(i, u);
    }, 0));
  }, P = function(i, u, v) {
    return G(i, u, E(i), v);
  }, J = function(i, u, v) {
    var g = E(u), F = jt(u, b, i, v, g, p, A);
    return F = G(u, F, g), F;
  }, dt = function(i) {
    var u = i.formattedValue;
    u === void 0 && (u = "");
    var v = i.input, g = i.source, F = i.event, h = i.numAsString, m;
    if (v) {
      var N = i.inputValue || v.value, O = Z(v);
      v.value = u, m = J(N, u, O), m !== void 0 && k(v, m, u);
    }
    u !== b && rt(H(u, h), { event: F, source: g });
  };
  Y(function() {
    var i = q.current, u = i.formattedValue, v = i.numAsString;
    (b !== u || U !== v) && rt(H(b, U), {
      event: void 0,
      source: z.props
    });
  }, [b, U]);
  var mt = D.current ? Z(D.current) : void 0, gt = typeof window < "u" ? At : Y;
  gt(function() {
    var i = D.current;
    if (b !== q.current.formattedValue && i) {
      var u = J(q.current.formattedValue, b, mt);
      i.value = b, k(i, u, b);
    }
  }, [b]);
  var ht = function(i, u, v) {
    var g = u.target, F = $.current ? Bt($.current, g.selectionEnd) : Tt(b, i), h = Object.assign(Object.assign({}, F), { lastValue: b }), m = s(i, h), N = st(m);
    if (m = s(N, void 0), x && !x(H(N, m))) {
      var O = u.target, T = Z(O), X = J(i, b, T);
      return O.value = b, k(O, X, b), !1;
    }
    return dt({
      formattedValue: N,
      numAsString: m,
      inputValue: i,
      event: u,
      source: v,
      input: u.target
    }), !0;
  }, Q = function(i, u) {
    u === void 0 && (u = 0);
    var v = i.selectionStart, g = i.selectionEnd;
    $.current = { selectionStart: v, selectionEnd: g + u };
  }, yt = function(i) {
    var u = i.target, v = u.value, g = ht(v, i, z.event);
    g && c(i), $.current = void 0;
  }, Ct = function(i) {
    var u = i.target, v = i.key, g = u.selectionStart, F = u.selectionEnd, h = u.value;
    h === void 0 && (h = "");
    var m;
    v === "ArrowLeft" || v === "Backspace" ? m = Math.max(g - 1, 0) : v === "ArrowRight" ? m = Math.min(g + 1, h.length) : v === "Delete" && (m = g);
    var N = 0;
    v === "Delete" && g === F && (N = 1);
    var O = v === "ArrowLeft" || v === "ArrowRight";
    if (m === void 0 || g !== F && !O) {
      S(i), Q(u, N);
      return;
    }
    var T = m;
    if (O) {
      var X = v === "ArrowLeft" ? "left" : "right";
      T = P(h, m, X), T !== m && i.preventDefault();
    } else
      v === "Delete" && !p(h[m]) ? T = P(h, m, "right") : v === "Backspace" && !p(h[m]) && (T = P(h, m, "left"));
    T !== m && k(u, T, h), S(i), Q(u, N);
  }, St = function(i) {
    var u = i.target, v = function() {
      var g = u.selectionStart, F = u.selectionEnd, h = u.value;
      if (h === void 0 && (h = ""), g === F) {
        var m = P(h, g);
        m !== g && k(u, m, h);
      }
    };
    v(), requestAnimationFrame(function() {
      v();
    }), f(i), Q(u);
  }, Vt = function(i) {
    i.persist && i.persist();
    var u = i.target, v = i.currentTarget;
    D.current = u, _.current.focusTimeout = setTimeout(function() {
      var g = u.selectionStart, F = u.selectionEnd, h = u.value;
      h === void 0 && (h = "");
      var m = P(h, g);
      m !== g && !(g === 0 && F === h.length) && k(u, m, h), w(Object.assign(Object.assign({}, i), { currentTarget: v }));
    }, 0);
  }, pt = function(i) {
    D.current = null, clearTimeout(_.current.focusTimeout), clearTimeout(_.current.setCaretTimeout), C(i);
  }, It = lt && _t() ? "numeric" : void 0, at = Object.assign({ inputMode: It }, B, {
    type: e,
    value: b,
    onChange: yt,
    onKeyDown: Ct,
    onMouseUp: St,
    onFocus: Vt,
    onBlur: pt
  });
  if (r === "text")
    return n ? R.createElement(R.Fragment, null, n(b, B) || null) : R.createElement("span", Object.assign({}, B, { ref: o }), b);
  if (a) {
    var wt = a;
    return R.createElement(wt, Object.assign({}, at, { ref: o }));
  }
  return R.createElement("input", Object.assign({}, at, { ref: o }));
}
function $t(t, e) {
  var r = e.format, a = e.allowEmptyFormatting, n = e.mask, o = e.patternChar;
  if (o === void 0 && (o = "#"), t === "" && !a)
    return "";
  for (var l = 0, s = r.split(""), y = 0, V = r.length; y < V; y++)
    r[y] === o && (s[y] = t[l] || ft(n, l), l += 1);
  return s.join("");
}
function qt(t, e, r) {
  e === void 0 && (e = kt(t));
  var a = r.format, n = r.patternChar;
  n === void 0 && (n = "#");
  var o = e.from, l = e.to, s = e.lastValue;
  s === void 0 && (s = "");
  var y = function(C) {
    return a[C] === n;
  }, V = function(C, d) {
    for (var E = "", p = 0; p < C.length; p++)
      y(d + p) && L(C[p]) && (E += C[p]);
    return E;
  }, I = function(C) {
    return C.replace(/[^0-9]/g, "");
  };
  if (!a.match(/\d/))
    return I(t);
  if ((s === "" || o.end - o.start === s.length) && t.length === a.length) {
    for (var x = "", c = 0; c < t.length; c++)
      if (y(c))
        L(t[c]) && (x += t[c]);
      else if (t[c] !== a[c])
        return I(t);
    return x;
  }
  var S = s.substring(0, o.start), f = t.substring(l.start, l.end), w = s.substring(o.end);
  return "" + V(S, 0) + I(f) + V(w, o.end);
}
function zt(t, e) {
  var r = e.format, a = e.mask, n = e.patternChar;
  n === void 0 && (n = "#");
  var o = Array.from({ length: t.length + 1 }).map(function() {
    return !0;
  }), l = 0, s = -1, y = {};
  r.split("").forEach(function(c, S) {
    var f = void 0;
    c === n && (l++, f = ft(a, l - 1), s === -1 && t[S] === f && (s = S)), y[S] = f;
  });
  for (var V = function(c) {
    return r[c] === n && t[c] !== y[c];
  }, I = 0, x = o.length; I < x; I++)
    o[I] = I === s || V(I) || V(I - 1);
  return o[r.indexOf(n)] = !0, o;
}
function Wt(t) {
  var e = t.mask;
  if (e) {
    var r = e === "string" ? e : e.toString();
    if (r.match(/\d/g))
      throw new Error("Mask " + e + " should not contain numeric character;");
  }
}
function Gt(t, e) {
  return t === "" ? !0 : !(e != null && e.match(/\d/)) && typeof t == "string" && (!!t.match(/^\d+$/) || t === "");
}
function Ht(t) {
  t.mask, t.allowEmptyFormatting;
  var e = t.format, r = t.inputMode;
  r === void 0 && (r = "numeric");
  var a = t.onKeyDown;
  a === void 0 && (a = M);
  var n = t.patternChar;
  n === void 0 && (n = "#");
  var o = t.value, l = t.defaultValue, s = t.valueIsNumericString, y = ot(t, ["mask", "allowEmptyFormatting", "format", "inputMode", "onKeyDown", "patternChar", "value", "defaultValue", "valueIsNumericString"]);
  Wt(t);
  var V = function(f) {
    return zt(f, t);
  }, I = function(f) {
    var w = f.key, C = f.target, d = C.selectionStart, E = C.selectionEnd, p = C.value;
    if (d !== E) {
      a(f);
      return;
    }
    var A = d;
    if (w === "Backspace" || w === "Delete") {
      var B = "right";
      if (w === "Backspace") {
        for (; A > 0 && e[A - 1] !== n; )
          A--;
        B = "left";
      } else {
        for (var K = e.length; A < K && e[A] !== n; )
          A++;
        B = "right";
      }
      A = G(p, A, V(p), B);
    } else
      e[A] !== n && w !== "ArrowLeft" && w !== "ArrowRight" && (A = G(p, A + 1, V(p), "right"));
    A !== d && tt(C, A), a(f);
  }, x = W(o) ? l : o, c = s ?? Gt(x, e), S = Object.assign(Object.assign({}, t), { valueIsNumericString: c });
  return Object.assign(Object.assign({}, y), {
    value: o,
    defaultValue: l,
    valueIsNumericString: c,
    inputMode: r,
    format: function(f) {
      return $t(f, S);
    },
    removeFormatting: function(f, w) {
      return qt(f, w, S);
    },
    getCaretBoundary: V,
    onKeyDown: I
  });
}
function Qt(t) {
  var e = Ht(t);
  return R.createElement(Ut, Object.assign({}, e));
}
export {
  Ut as NumberFormatBase,
  Qt as PatternFormat,
  zt as getPatternCaretBoundary,
  $t as patternFormatter,
  qt as removePatternFormat,
  Ht as usePatternFormat
};
